<template>
  <div class="gold_main">
    <div class="gold_banner">
      <img src="../../assets/images/img2/string_banner.png" alt="" />
    </div>
    <div class="con">
      <div class="index_mod1top">
        <div class="index_mod1text">
          <p class="index_mo1tit1">购买享优惠</p>
          <p class="index_mo1tit2">购买钜惠不停狂欢继续</p>
        </div>
        <div class="index_mod1bg"></div>
      </div>
      <div class="gold_list">
        <div
          class="gold_li string_li"
          v-for="(item, index) in zifubao"
          :key="index"
          @click="payStringPack(item)"
        >
          <img
            src="../../assets/images/img2/string_bg.png"
            class="string_libg"
          />
          <div class="string_licon">
            <p class="string_limun">
              <span>{{ item.zfnum }}</span>
              <span>字</span>
            </p>
            <p style="font-size: 16px">{{ item.per }}</p>
            <p class="string_liprice">
              <span>原价￥{{ item.rmbshow }}</span>
              <span>￥{{ item.rmb }}</span>
            </p>
            <div class="string_libtn">立即开通</div>
          </div>
        </div>
      </div>
    </div>
    <div class="pay_gold" v-if="show_pay">
      <div class="pay_goldmg" @click="hidePay"></div>
      <div class="pay_goldcon">
        <p style="font-size: 18px; font-weight: bold; text-align: center">
          {{ rmb }}元
        </p>
        <p style="font-size: 12px; color: #666; text-align: center">
          {{ initData() }}
        </p>
        <p
          style="
            width: 384px;
            height: 1px;
            border: 1px solid #eeeeee;
            margin: 20px auto;
          "
        ></p>
        <div class="gold_code" v-loading="loading">
          <img :src="code_url" v-show="code_url" />
        </div>
        <p style="text-align: center">微信支付</p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["zifubao"]),
  },
  watch: {
    $route(to, from) {
      clearInterval(this.paytime);
    },
  },
  data() {
    return {
      show_pay: false, // 支付界面显示状态
      code_url: "", // 支付二维码图片地址
      crgid: "", // 支付id
      item: "", //当前支付选项
      paytime: null, //支付检查计时器
      rmb:0,//当前支付价格
    };
  },
  methods: {
    //显示日期在页面上
    initData() {
      var date = new Date();
      //年
      var year = date.getFullYear();
      //月
      var month = date.getMonth() + 1;
      //日
      var day = date.getDate();
      //时
      var hh = date.getHours();
      //分
      var mm = date.getMinutes();
      //秒
      var ss = date.getSeconds();
      var rq = year + "年" + month + "月" + day + "日" + hh + ":" + mm;
      return rq;
    },
    // 隐藏支付
    hidePay() {
      this.show_pay = false;
      clearInterval(this.paytime);
    },
    // 购买字符包
    payStringPack(item) {
      // 判断登录状态
      if (this.$globalFun.judgeNotLogin(this) && issave) return;
      let self = this;
      this.rmb = item.rmb
      this.code_url = "";
      this.$globalFun.getPay(
        this,
        2,
        2,
        "购买字符包",
        Number(item.rmb),
        0,
        "",
        { zfnum: item.zfnum },
        (res) => {
          console.log(res);
          self.show_pay = true
          self.code_url = res.model.orderparams4webchat.code_url;
          self.crgid = res.model.crgid;
          self.loading = false;
          self.verifyPay();
        }
      );
    },
    // 验证支付
    verifyPay() {
      let self = this;
      clearInterval(self.paytime);
      this.paytime = setInterval(() => {
        if (self.crgid == "") return;
        let url =
          self.$store.state.base_api + self.$store.state.base_url.qryorderinfo;
        let json = {
          crgid: self.crgid,
        };
        self.$request.postHttp(json, url, (decdata) => {
          if (decdata.model.status !== "1") return;
          //支付成功清除计时器
          clearInterval(self.paytime);
          self.show_pay = false;
          self.$globalFun.getUserInfo(self);
          self.$alert("充值成功！", "提示", {
            confirmButtonText: "确定",
          });
        });
      }, 3000);
    },
  },
};
</script>

<style>
@import url("../../assets/css/gold.css");
</style>


// WEBPACK FOOTER //
// src/view/recharge/string_pack.vue